import {
    fetchMheValidationDetails, getPresignedURL, triggerMheValidationDetails
} from "../network/MHEValidationNetworkAPI";

export const MHEValidationReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingValidationDetails: false}
        case "LOAD_VIEW":
            fetchMheValidationDetails(action.data.dispatcher, action.data.macAddress)
            return state
        case "TRIGGER_VALIDATION":
            triggerMheValidationDetails(action.data.dispatcher, action.data.triggerData, action.data.showCustomAlert)
            return state
        case "GET_PRESIGNED_URL":
            getPresignedURL(action.data.dispatcher, action.data.objectKey, action.data.showCustomAlert)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/mhevalidation/reducers/MHEValidationReducer.js